export const GET_DELIVERY_DETAILS = '/api/track/order/trackOrder';
export const GET_TRACK_DETAILS = '/api/track/order/trackPath';
export const GET_ETA = '/api/track/order/eta';
export const GET_AGENT_IMAGE = '/api/track/order/agentImage';
export const GET_TIMELINE_IMAGE = '/api/track/order/deliveryImages/';
export const SUBMIT_USER_RATING = '/api/track/order/feedback';
export const ACC_IMAGE = '/api/track/order/accountLogo/deliveryTokenId/';
export const ACCOUNT_SELF_LOGO = '/api/account/self/logo';
export const DELIVERY_PROOF = '/api/track/order/uploadFile/deliveryStatus/';
export const GET_ORDER_STATUS = '/api/track/order/isActive'
export const GET_CARRIER_DATA = "/api/track/order/carrierData"
export const FIELD_TO_INCLUDE = 'type,stars,comments'
export const GET_FEATURE_VISBILITY_PROPERTIES = '/api/track/order/properties'
export const GET_ORDER_TRACK_INFO = '/api/track/order/orderTrackInfo'
export const GET_ORDER_DATA_INFO = '/api/track/order/orderData'
export const GET_ORDER_DATA_INFO_GRAPHQL = '/api/zenGraphql/id/673b349fb95fefed9e483139'
export const GET_ORDER_TRACK_INFO_CONFIG_GRAPHQL = '/api/zenGraphql/id/678793982e992ed7f70eb34c'
export const GET_ACCOUNT_LOGO_GRAPHQL = '/api/zenGraphql/id/678792792e992ed7f70eb0e9'


export const SOCKET = {
  NAMESPACE: '/deliveryManagement/customerlink/',
  EVENTS: {
    LIVE_STATUS: 'live_status',
    LIVE_TRACK: 'live_track',
    DISCONNECT: 'disconnect',
    CONN_ERROR: 'connect_error',
    ERROR: 'error',
    CONNECT: 'connect',
    CONNECTING: 'connecting'
  }
}


export const STATUS = {
  delivered: "Delivered",
  inProgress: "In Progress",
  cancelled: "Cancelled",
  notStarted: "Not Started",
  Unassigned: "Un Assigned",
  assigned: "Assigned",
  pickedUp: "Picked Up",
  deliveryPartnerDeclinedPickedUp: "Pickup Declined",
  deliveryPartnerRejectedOrder: "Rejected",
  deliveryPartnerAcceptedOrder: "Accepted",
  deliveryPartnerReturnedOrder: "Returned",
  manual: "Manual",
  shopify: "Shopify",
  deliveryInProgress: 'Delivery In Progress',
  orderCreated: 'Order Created',
  lpCancelled: 'Logistic Provider Cancelled'
}


